import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "iframe", "backdrop"]
  static values = {
    url: String
  }

  connect() {
    // Bind escape key handler
    this.handleEscape = this.handleEscape.bind(this)
  }

  open() {
    const videoUrl = `${this.urlValue}?autoplay=1`
    this.iframeTarget.src = videoUrl
    this.modalTarget.style.display = 'flex'
    
    // Trigger reflow to enable transition
    this.modalTarget.offsetHeight
    this.modalTarget.classList.add('active')
    document.body.style.overflow = 'hidden'
    
    // Add escape key listener
    document.addEventListener('keydown', this.handleEscape)
  }

  close() {
    this.modalTarget.classList.remove('active')
    
    setTimeout(() => {
      this.modalTarget.style.display = 'none'
      this.iframeTarget.src = ''
      document.body.style.overflow = ''
    }, 300)
    
    // Remove escape key listener
    document.removeEventListener('keydown', this.handleEscape)
  }

  closeOnBackdrop(event) {
    if (event.target === this.backdropTarget) {
      this.close()
    }
  }

  handleEscape(event) {
    if (event.key === 'Escape' && this.modalTarget.classList.contains('active')) {
      this.close()
    }
  }

  disconnect() {
    // Clean up event listener if controller is removed
    document.removeEventListener('keydown', this.handleEscape)
  }
}
